module.exports = __webpack_public_path__ + "static/media/pp_regular_paper_straw_green3.6fd1c826.png";